module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch02"
    }
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterNumber",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', {
    staticClass: "bold"
  }, [_c('span', [_vm._v("CHAPTER TWO")])])])])]), _c('div', {
    staticClass: "chapterBody"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_c('p', {
    staticClass: "chapterOpenerText",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("“"), _c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', [_vm._v("W"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("HY DIDN’T YOU")])])])]), _vm._v(" like him?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bree looked up from her salad. There it was, the question she’d been waiting for since Fallon phoned and asked her out to lunch. The only surprise was that it had taken her sister a week to make the call and almost half an hour to ask the question.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Who?” Bree said innocently. Why give away more than was necessary?")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You know who. Gianni Firelli.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Bree popped a grape tomato into her mouth and chewed contemplatively. She had two choices. She could say “Who?” and pretend not to know what her sister was talking about, or she could tell her to mind her own business. Neither response was going to get her very far. Growing up, she’d learned what that determined tilt of her eldest sister’s chin meant.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The best thing was to tackle this head-on.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I assume,” she said, putting down her fork, “we’re talking about the fact that I didn’t fall at the man’s feet.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Fall at his feet? A simple ‘Hello, nice to meet you,’ would have done it.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I said ‘hello.’”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You know what I mean, Bree. You almost took his head off.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I did not.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, you did. I can’t believe you behaved so badly!”")])])]), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Behaved so badly? Bree’s chin lifted, just like Fallon’s. “And "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("I")])]), _vm._v(" can’t believe you still think I’m six years old.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You were rude.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I was honest.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Being rude isn’t being honest.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your opinion, not mine. Are you going to eat that last croissant?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No. And don’t change the subject.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I’m not changing anything. I just don’t want to be badgered.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your manners were appalling.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know how to break this to you,” Bree said sweetly, “but you’re my sister, not my mother.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And a good thing, too. If Ma’s plane hadn’t landed late, she’d have been at the party in time to see you in action. Can you imagine how she’d have reacted?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No.” Bree’s tone had gone from sugary to saccharine. “Why don’t you tell me?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Obviously Big Sister hadn’t expected a reply to what she’d meant as a rhetorical question.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, she’d have—she’d have—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Sent me to my room without supper? Docked my allowance?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The sisters glared at each other. Then Fallon sighed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Okay, maybe I’m overreacting.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hallelujah,” Bree said, picking up her fork again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But you really were abrupt.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I wanted to be sure Mr. Firelli got the message.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Which was?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“That I wasn’t interested.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Gianni’s a very nice guy.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No doubt.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“And he’s good-looking.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Good-looking?” Bree shrugged, put down her fork and reached for the butter. “I suppose.”")])])]), _c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Give me a break! You know he’s good-looking.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What I know,” Bree replied, breaking off a piece of croissant and buttering it, “is that Gianni Firelli is gorgeous.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well, of course he is. He’s…” Fallon blinked. “What did you say?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You heard me. He’s, what, six-one? Six-two? Shoulders out to here, solid muscle straight down to his toes, black hair, green eyes, a face like a Greek god’s—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Italian,” Fallon said, staring at her.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“A minor detail. The point is, the man’s incredible. An out-and-out hottie.” Bree reached for her glass of white wine and smiled at the dumbstruck expression on her sister’s face. “Give me a break, Fallon. I’m not dead! Did you think I hadn’t noticed?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“I don’t know what I thought,” Fallon said, sitting back in the booth. “Tell me more.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“What more is there? I’m sure there were a dozen women at your party who’d have happily killed for the chance to be introduced to him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“But, as I already told Karen—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Karen?” Fallon said, bewildered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Karen Massini. Tomasso’s wife.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh. Right. I keep forgetting you and she knew each other before I married Stefano.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Only for years and years,” Bree said, rolling her eyes. “We were friends in college. Close friends. Then she married Tomasso, moved to California and we lost touch, but ever since she got pregnant and they moved back to New York—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes, okay, I remember,” Fallon said, impatient to return to the current topic. “So, you and Karen talked about Gianni?”")])])]), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“She said she’d noticed him looking at me and…You know how these things go.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Fallon wanted to reach across the table and shake her sister. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Don’t try to play matchmaker, cara")])]), _vm._v(", her husband had told her at breakfast. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Gianni and Briana didn’t connect. End of story")])]), _vm._v(". Stefano had taken her in his arms. "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("Not everyone is lucky enough to fall in love at first sight")])]), _vm._v(".")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("No. Not in love, perhaps, but something had happened between Stefano’s old friend and her baby sister. Fallon was certain. Karen wasn’t the only one who’d noticed the way he’d looked at Bree. And the way Bree had looked at him, even as she was giving him the brush-off.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“No,” she said carefully, “I don’t know how these things go. What did Karen say?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh, I don’t remember, exactly.” Bree patted her lips with her napkin and pushed away her plate. “Something about me taking pity on the guy and at least giving him a smile.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You see? You were so impolite that people noticed. Poor Gianni.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Poor Gianni,” Bree said, the words coated with sarcasm, “needs your sympathy the way a bear needs a fur coat. He has a mistress.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Oh.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yes. Oh. A mistress, and he was coming on to me anyway. What do you think of him now? Or didn’t he bother mentioning that we’d met in the elevator and he tried a pickup line before the doors had the chance to shut?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Well,” Fallon said, thinking back to the first time she and her husband met, “well—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Look, there’s just something about the guy I don’t like, okay? End of story.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_c('span', [_vm._v("“Bree. Honey, you’ve gone through how many relationships? Sooner or later, there’s always something about the ")])]), _c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_vm._v("guy you don’t like, whatever that means. Don’t make a face. I know you’re a big girl—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“An adult,” Bree said coolly, “but neither you nor Megan seem able to hang on to that thought.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“We just want you to be happy. To find someone to love.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Lust isn’t love.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Fallon blushed. “Sometimes it’s the way love begins.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Well, not for me.” Bree’s expression turned dreamy. “I’ll meet the right man someday. He’ll be gentle and sweet. He’ll never do anything to upset me. He might not stand out in a crowd, but—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“What about passion?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Sex isn’t all it’s cracked up to be.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Passion isn’t only about sex,” Fallon said softly, “but if you think that making love isn’t special, you haven’t been with the right man.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Sex Ed 101,” Bree said and, just as she’d hoped, her sister laughed. Good. She really didn’t want to get into this topic. “Don’t worry about me, okay? And lunch is on me. No arguments.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Fallon watched Briana rummage in her handbag. “Bree?” she said, so softly that Bree looked up. “This passion thing. I know you. You’re full of fire. Full of life. Why would you want to deny it?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Amazing,” Bree replied, trying for a light tone. “Karen made the same speech. Do the two of you really think you know what’s best for me?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“I barely know Karen, but I admire her insight. Did you ever consider we might be right? Maybe you’re kidding yourself. Maybe what you really want is a man who’ll sweep you off your feet?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("Briana’s eyes flashed. Fallon had pushed too far. It was time for the truth.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page19"
    }
  }, [_c('span', [_vm._v("“Sweep me off my feet, huh? Like our father did to our ")])]), _c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_vm._v("mother?” She leaned forward, all attempts at good humor gone. “I was the baby, so maybe you think I don’t remember, but I do. Ma struggling to pretend it was okay with her whatever he did, smiling when she wanted to cry, never saying an unkind word to him or about him.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Bree—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Our mother turned herself into a doormat because of that ‘sweeping her off her feet’ crap. She lived for our father, lived "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("through")])]), _vm._v(" him, and if you think I’m going to let myself in for the same nonsense, you’re crazy!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Is that how you think of me?” Fallon said quietly. “As a doormat for my husband?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“No! I didn’t mean—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Stefano swept me off my feet. Qasim swept Megan off hers, and one look at our sisters-in-law and I could tell it was the same for them. We’re all head over heels, passionately in love with our husbands. Are we all doormats?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“No, no, I never…” Bree took a steadying breath. “This is pointless,” she said. “I’m just not looking for passion. If it works for you, great, but I know myself. I want—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Something quiet.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Yes.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Something undemanding.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“There’s nothing wrong with that!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Something safe,” Fallon said softly, and reached for Bree’s hand. “What are you afraid of, sis?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("“Nothing,” Briana said quickly, and even as she said it, she knew she was lying.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("She "), _c('em', {
    staticClass: "italic"
  }, [_c('span', [_vm._v("was")])]), _vm._v(" afraid. Of the dreams she’d had about Gianni Firelli each night since the party. Of the way he’d made her feel. Of that one cataclysmic instant when she’d looked into his eyes and felt the earth tilt under her feet.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span', [_vm._v("Of losing herself, her dreams, her hopes, her very being, in the fires of passion.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page20"
    }
  }, [_c('span')])]), _c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('span', [_vm._v("M"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("AY BECAME JUNE")])]), _vm._v(", and June slipped into July.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("The days were hot and muggy. New Yorkers who could afford it abandoned the city in droves. You were more likely to bump into your Fifth Avenue neighbor on the beaches in the Hamptons or on village greens in the Connecticut hills than in the city.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni didn’t notice the heat. He was immersed in a trial that was finally nearing its conclusion. It had been a complicated case, one that required his personal attention. He’d gone back and forth to the coast several times, even now, in the trial’s final hours. Days took on a numbing similarity when you spent them on airplanes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Invitations came in, as they always did: dinner parties at the beach, long weekends in the country. He hadn’t dated anyone since the break-up with Lynda. Word had gotten out and hostesses everywhere were doing their best to inveigle him into meeting eligible women, but he wasn’t in the mood. He wasn’t in the mood for parties, either. Not since May. Not since Briana O’Connell had treated him with a curtness that had bordered on contempt. He needed closure.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Entering his penthouse on a Friday evening, tired after another round of flights and depositions, Gianni grimaced at that overused word. Closure was the feel-good term of the decade.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("In this case, though, it was true.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He shrugged off his jacket, undid his tie and the buttons on his shirt as he made his way to the bedroom.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Lack of closure was why he couldn’t get what had happened out of his mind. He was furious with himself that he hadn’t told the lady what he thought of her, but how could he? He’d been a guest in Stefano’s home, and she was Stefano’s sister-in-law.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page21"
    }
  }, [_c('span', [_vm._v("Gianni tossed his cuff links on the dresser, added his wallet and change, peeled down to his briefs and started for the ")])]), _c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_vm._v("shower before remembering the heavy vellum envelope the doorman had given him. It had been hand-delivered.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Gianni eyed the envelope narrowly. It was, surely, some kind of invitation. The delivery by messenger, the vellum stock were dead giveaways. Well, whatever he’d been invited to, he wasn’t going. He wasn’t in the mood for people and small talk but someone, somewhere was waiting for an answer and he believed in being polite even if…")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Hell.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("He tore open the envelope and felt his bad mood dissolve. Tomasso and Karen had had their baby. A girl. His smile turned into a grin. They were having a Welcome to the World party for the child. Karen’s idea, without question. Gianni didn’t know her well but from what he’d observed and from what Tomasso said, Karen was the antithesis of her pragmatic husband. She was day to his night, Tomasso had told him with the kind of smile that made it clear it was a winning combination.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Gianni’s grin faded. Damn it, the party was tonight.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Sighing, he shut his eyes and rubbed the back of his neck. Lord, he was tired. The last thing he was in the mood for was a party, but another life had come into the world and even if he couldn’t yet understand the appeal of fatherhood, he wanted to clap Tomasso on the back, kiss Karen and wish them well.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Gianni dropped the invitation on the dresser and headed for the shower.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Tonight, at least, nobody would try to play matchmaker, not with the baby the center of attention.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("Better still, there wasn’t a snowball’s chance in hell he’d run into Briana O’Connell.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("“Hallelujah,” he muttered, and stepped under the spray.")])])]), _c('p', {
    staticClass: "spaceBreak",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span')])]), _c('p', {
    staticClass: "paraNoIndent",
    staticStyle: {
      "text-indent": "0%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("S"), _c('span', {
    staticClass: "smallCaps"
  }, [_c('span', [_vm._v("O MUCH")])]), _vm._v(" for snowballs and hell.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page22"
    }
  }, [_c('span', [_vm._v("He ran into the Ice Princess just minutes after walking ")])]), _c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_vm._v("into the party. At least, he would have if he hadn’t spotted her and come to a screeching halt.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("She was standing with a group of people, her back to him, but that didn’t matter. The hair tumbling down her back, the endless legs, showcased by heels so spiked they should have been declared a hazard to a man’s health, were dead giveaways.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("All her attention was focused on a guy doing his best to make her laugh. Damned if he wasn’t succeeding.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("Gianni felt his muscles tense. This woman laughed easily for anybody but him.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("What was she doing here? Tomasso, he thought grimly, and just then, Tomasso had the misfortune to stroll by. Gianni grabbed his shoulder and glared.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Did you invite her?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Invite who?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Damn it, Tomasso…No. You wouldn’t do that to me. It was Fallon.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“It was Fallon what?” Tomasso said, his bewilderment so genuine that Gianni knew he was blameless.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Fallon who put Karen up to this. To inviting Briana O’Connell.” Gianni jerked his head in Bree’s direction. “Stefano’s wife is the only one who’d—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Nobody put Karen up to anything. Briana is Karen’s best friend.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("It was Gianni’s turn to look shocked. “Her best friend?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Well, they’d been out of touch for a few years, but yeah, best pals, way back when. They went to college together. Roomed together. They were sorority sisters. You know, the whole nine yards.” Tomasso raised an eyebrow. “What’s the problem?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Nothing,” Gianni said wearily. “There’s no problem.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“You sure?” Tomasso offered a friendly leer. “You and she have something going on?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page23"
    }
  }, [_c('span', [_vm._v("“Only if you’d describe a spider as having something ")])]), _c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_vm._v("going on with a fly.” Gianni laughed and slung his arm around the other man’s shoulders. “How about taking me to meet that new daughter of yours?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("The baby was cute, as babies went. The food was good, the ale was cold, and twenty minutes after he’d arrived, Gianni was ready to leave.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("World War Three had not erupted. The Ice Princess either didn’t know he was here or she knew he was here and was ignoring him. She was still chatting with the same group of people. The only thing that had changed was that now he could hear her laugh.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("It was the laugh he’d heard at Stefano’s. Husky. Sexy. Secretive.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("It was driving him out of his mind.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("How could she laugh when he was so royally ticked off? How come she didn’t know he was here? She had to know. He hadn’t been aware of the connection between her and Karen, but she’d certainly known he and Tomasso were friends, and—")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("And, he didn’t have to worry about her driving him insane because he was already climbing the steps of the asylum. Why else would he stand here watching her? Why would he give a damn? Why would he feel his temper rising and his blood pressure increasing?")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("Okay. All right. Closure. Wasn’t that what he’d wanted? He felt a muscle jump in his cheek. Closure was what he’d get, and right now.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("There must have been something in his face as he strode across the room because the people she was with fell silent. Only one man was still laughing; a look from him and the laugh turned into something that sounded like a caw.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("“What’s the matter?” Briana O’Connell said.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page24"
    }
  }, [_c('span', [_vm._v("She swung around and he saw the surprise and something more flash across her face, something he would have missed if he weren’t feeling it himself.")])])]), _c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Desire, hot, raw and savage, sluiced through his blood.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You,” she said, so dramatically that he almost laughed.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Me,” he said, and reached for her arm.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Hey.” She tried to pull away. He wouldn’t let her. “What do you think you’re doing?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Yeah,” the man who’d been laughing said, “what do you think you’re doing?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni swung toward him. “Whatever I’m doing,” he said pleasantly, “it’s none of your business.” The guy’s face turned a sickly grey. Okay. Maybe he didn’t say it pleasantly. “The lady and I have things to discuss.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He looked at Briana. Her face was as pink as the guy’s was grey. He could see the pulse beating in her throat. Was she afraid of him? She ought to be. He’d had about all he was going to take.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You’re crazy. We have nothing to—”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She gasped as he slid his hand to her wrist and encircled it.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Don’t give me a hard time.”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“You son of a bitch,” she said, her voice trembling, but it was there again, swift as the beat of a hummingbird’s wing, that flash of heat flaring in her eyes.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("Gianni stepped closer.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Your choice, princess. Are you coming with me, or do I pick you up and carry you?”")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("“Bree?” the guy said, and Gianni grudgingly gave him credit for having more balls than brains.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("She hissed a word he hadn’t thought she’d know, then slicked the tip of her tongue across her bottom lip. He felt his body tighten in response. When she tore her hand from his, he let her do it. He knew it was the small victory she needed so she could spin on one of those wicked stiletto heels and head for the front door.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('span', [_vm._v("He was no more than a step behind her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page25"
    }
  }, [_c('span', [_vm._v("Did somebody call his name? He didn’t know, didn’t ")])]), _c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_vm._v("care, didn’t think about anything but the swing of her buttocks, the way her short lemon-yellow skirt flared around her thighs as she strode from the apartment.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("The elevator was just outside, waiting for them as if he’d planned it. She stepped into the car and jabbed a button. He stepped inside and she tried to shoot past him just as the door began to close. His vision clouded; he grabbed her arm and spun her toward him as the doors slid shut.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“Let go of me!” She jerked under his hands, eyes hot, breasts rising and falling with each quick breath. “What in hell do you think you’re doing?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“What I should have done the day we met,” he said, and he hauled her against him and kissed her.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("She cried out, but the sound was lost against his plundering mouth. She beat her fists against his shoulders and tried to twist her face away from his but he tunneled his hands into her hair, angled her face to his, and kissed her again.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“Bastard,” she panted, “you no good bas—”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("And then she wound her arms around his neck and opened her mouth to his.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("The first taste of her and he was lost. She fell back against the wall of the car, her body arching against his, breasts soft against his chest, hips lifting to the thrust of his.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“Oh God,” she whispered. “Oh please…”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("Gianni groaned, cupped her backside and lifted her. She wrapped her legs around him, pressed herself against his erection and he felt a rush of desire so primitive it was almost his undoing.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“Tell me,” he said. “Say it. Say you want me. That you want this.”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("“Yes. Yes!”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page26"
    }
  }, [_c('span', [_vm._v("He slid his hand under her skirt. Only a scrap of lace lay between his questing fingers and her flesh. She was hot and ")])]), _c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_vm._v("wet and when he felt her against his palm, he had to fight for control all over again.")])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("He stroked her, then slid a finger inside the damp fabric that kept him from her, and she cried out, dug her fingers into his hair, kissed him with the same urgency he felt, the same blind need.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("And the car rocked to a stop.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("The doors opened. They must have, because the next thing he knew, he heard a startled gasp, a laugh, saw Briana’s eyes open, heard her horrified cry.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Gianni didn’t turn around. He reached out blindly to the control panel and hit a button. The doors shut. The elevator began to descend again.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Briana,” he said, “Bree…”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("She twisted against him with the desperation of a wild creature caught in a trap and struck out with her fist. He grunted when one blow connected with his jaw.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Damn it,” he said, grabbing her hands as she slid down his body, “will you listen to me?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("The elevator reached the lobby. She shot from the car as if the demons of hell were at her heels. The surprised doorman yanked the front door wide with only seconds to spare, then stared at Gianni.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Sir? Is everything all right?”")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("Gianni drew a ragged breath as he stepped from the car.")])])]), _c('p', {
    staticClass: "para",
    staticStyle: {
      "text-indent": "5%"
    }
  }, [_c('a', {
    attrs: {
      "id": "page27"
    }
  }, [_c('span', [_vm._v("“Everything’s fine,” he said, and knew it was the biggest lie he’d ever told in his life.")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-f97a7eaa","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sicilianmarriagethe_ch02.vue
// module id = 72
// module chunks = 0